<template>
  <!-- 生产单详情-工单部分  -->
  <!-- 这里的概念是创建前是机台项，创后才能算工单 -->
  <el-table
    ref="multipleTable"
    :data="workOrders"
    height="300"
    style="width: 100%" border
    :row-style="{height: '0'}"
    :cell-style="{padding: '0px'}" :header-cell-style="{padding: '0px'}">
      <el-table-column v-for="(obj,key,index) in workOrderKeys" :key="index"
        :label="obj.value" :prop="key" :align="obj.align" :width="obj.width"/>
  </el-table>
</template>

<script>
  export default {
    data() {
      return {
        workOrders: [],
        workOrderKeys: {
          number: { value: '工单编号', align: 'center', width: '100' },
          precent: { value: '工单进度', align: 'center', width: '80' },
          nowProducedLength: { value: '已生产数量(米)', align: 'right', width: '100' },
          predictProducedLength: { value: '预生产数量(米)', align: 'right', width: '100' },
          productInProgress: { value: '工单状态', align: 'center', width: '70' },
          dropClothLength: { value: '落布数(米)', align: 'center', width: '100' },
          doorWidth: { value: '幅宽(毫米)', align: 'center', width: '160' },
          doorCount: { value: '门幅数', align: 'center', width: '50' },
          speed: { value: '车速(分钟/转)', align: 'center', width: '100' },
          productStartTime: { value: '首次上机时间', align: 'center', width: '' },
          productFinishTime: { value: '最后下机时间', align: 'center', width: '' }
        }
      }
    },

    methods: {
      // 设置工单信息
      setWorkOrders(response) {
        this.workOrders = this.formatWorkOrders(response)
      },
      // 格式化工单信息
      formatWorkOrders(res) {
        res.forEach(item => {
          item.productInProgress = item.productInProgress ? '生产中' : '未生产'
          item.nowProducedLength = item.nowProducedLength / 100
          item.predictProducedLength = item.predictProducedLength / 100
          item.productFinishTime = this.utils.timestampToTime(item.productFinishTime)
          item.productStartTime = this.utils.timestampToTime(item.productStartTime)
          item.precent = item.predictProducedLength <= 0 ? 0 : ((item.nowProducedLength / item.predictProducedLength) * 100).toFixed(2) + '%'
        })
        return res
      }
    },
    created() {
    },
    watch: {
    }
  }
</script>

<style scoped>
.table-input {
  height:100%;width:100%;border:0px;outline:none;padding:0;margin:0;
  text-align: center;
}
</style>
